import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { PhrasingHeader } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Phrasing/Header/PhrasingHeader";
import { PhrasingBody } from "./Body/PhrasingBody";

export interface IPhrasingState {
    headerProblem: string;
    headerDifficulty: number;
    bodyTexts: string[];
    bodyPart: string;
    bodyDifficulty: number;
}

export function Phrasing() {
    const [state, setState] = React.useState<IPhrasingState>({
        headerProblem: "",
        headerDifficulty: 5,
        bodyTexts: [],
        bodyPart: "gut",
        bodyDifficulty: 5,
    });

    ShareState(ESharedFunction.Phrasing_state, state, setState);

    return (
        <div
            style={{
                textAlign: `center`,
                margin: "20px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
            }}
        >
            <div style={{ margin: `5px` }}>
                {state.bodyTexts.map((text) => (
                    <div>{text}</div>
                ))}
            </div>
            <PhrasingHeader />
            <PhrasingBody />
        </div>
    );
}
